import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import * as yup from 'yup';

import { ButtonsCollection, ModalWindow, FormsCollection } from '../../ui-kit';
import './style.sass';

const rules = yup.object().shape({
  name: yup
    .string()
    .required({
      message: 'Name is required',
    })
    .max(64, {
      message: 'Name is too long',
    }),
});

const CreateModuleModal = ({
  isOpen,
  onClose,
  onSubmit,
  isPending,
}) => {
  const formik = useFormik({
    initialValues: { name: '' },
    enableReinitialize: true,
    validationSchema: rules,
    onSubmit: ({ name }) => onSubmit(name),
  });

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm({ name: '' });
    }
  }, [isOpen]);

  return (
    <ModalWindow
      isOpen={isOpen}
      onClose={onClose}
      title="Create module"
      className="create-module__modal"
    >
      <div onClick={(e) => e.stopPropagation()} role="none">
        <FormsCollection.FormWrapper
          handleSubmit={formik.handleSubmit}
          className="create-module"
        >
          <div className="create-module__row">
            <FormsCollection.Input
              name="name"
              placeholderJump="Module name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
              error={formik.errors.name}
              touched={formik.touched.name}
              className="create-module__name-field"
              id="create-module__name"
            />
          </div>
          <div className="button-group">
            <ButtonsCollection.ButtonBrill
              pending={isPending}
              className="button--md create-module__button-save button-brill--fill"
              type="submit"
            >
              Create
            </ButtonsCollection.ButtonBrill>
          </div>
        </FormsCollection.FormWrapper>
      </div>
    </ModalWindow>
  );
};

CreateModuleModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isPending: PropTypes.bool,
};

CreateModuleModal.defaultProps = {
  isPending: false,
};

export default CreateModuleModal;
